module.exports = __webpack_public_path__ + "img/Qrcode.3c082c79.jpg";